<template>
  <header id="header_dp" class="mandant">
    <div class="header_top">
      <div class="inner clearfix">
        <div class="mw320log">
          <div class="logowrap">
            <a class="block" :href="$root.linkHref('/'+tenant.alias)">
              <img v-if="tenant.id === 2501" class="logodpartner haub" src="../images/logo_derpart_haub.svg" alt="DERPART Logo"/>
              <img v-else class="logodpartner" src="../images/logo_partner.svg" alt="DERPART Logo"/>
            </a>
          </div>
        </div>
        <div v-if="!tenant.isAdac" class="mw320 hidden-xs">
          <div class="mandanteninfo c1 left" v-html="printName"></div>
        </div>
        <div id="hira" :onclick="$root.flyoutLink('{left:-10,top:3}')">
          <div id="hirah"><span class="dtxt">Persönliche Wunschreise</span><span class="mtxt">Wunschreise</span></div>
          <div id="hiraa">Anfragen</div>
          <div id="hirai"></div>
        </div>
        <nav id="mainnav">
          <div class="mw320 clearfix">
            <span id="mobilenav" @click="$root.toggleMobileNav" class="mobilenav mtxtinline js_mobilenav"></span>
            <div class="hidden-xs">
              <ul class="nav_topmain_1">
                <li v-for="item in nav.topMain" class="nav_topmain_1_li">
                  <a class="nav_topmain_1_link"
                     :id="$root.linkId('nav_topmain_1_',item)"
                     :href="$root.linkHref(item)"
                     :target="$root.linkTarget(item)"><span>{{ item.l }}</span></a>
                </li>
              </ul>
            </div>
            <div class="clearfix">
              <div class="visible-xs hidden-md">
                <div v-html="printName" class="mandanteninfo"></div>
              </div>
            </div>
          </div>
        </nav>
        <navigation-mobile :nav="nav.mobile" ref="mobileNav"/>
      </div>
    </div>
    <div class="header_sub dtxtblock">
      <div class="inner">
        <div id="subnav">
          <ul class="nav_themetop_1">
            <li v-for="item in nav.themeTop">
              <a :href="$root.linkHref(item)" :target="$root.linkTarget(item)">
                <span>{{item.l}}</span>
              </a>
            </li>
          </ul>
          <div class="clear"></div>
        </div>
        <div id="subnavmore">
          <span class="right"><a id="nav_themennav" @click="$root.toggleThemeMore" href="javascript:void(0)">Mehr Reisen</a></span>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </header>
  <section id="nav_theme">
    <div id="nav_theme_wrap">
      <div id="nav_theme_list" class="inner">
        <ul class="nav_theme_1">
          <li v-for="item in nav.themeMore" class="nav_theme_1_li">
            <a :href="$root.linkHref(item)" :target="$root.linkTarget(item)">
              <span>{{item.l}}</span>
            </a>
          </li>
          <li class="clear"></li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import navigationMobile from "@/components/navigation-mobile";

export default {
  name: "partner-header",
  components:{navigationMobile},
  props:{
    tenant:{
      type: Object,
      required: true,
    },
    nav:{
      type:Object,
      required: true,
    },
  },
  data(){
    return {
      mobileNavOpen:false
    }
  },
  computed:{
    printName(){
      return this.tenant.nameDp??this.tenant.name
    }
  },
}
</script>

<style scoped>

</style>